import { ComponentsTypes, READONLY_COMPONENT_TYPES } from '@/constants/componentsTypes';

const isReadonlyComponentType = (componentType: string): boolean => {
  return READONLY_COMPONENT_TYPES.includes(componentType as ComponentsTypes);
};

export const useDynamicComponent = () => {
  return {
    isReadonlyComponentType,
  };
};
